import React from 'react';
const faqs = [{
  q: '¿Para quién es esta colección?',
  a: 'Para adultos que tienen dificultad para dormir por rumiación y ansiedad nocturna. No importa si hace una semana o 5 años que lo vivís. El sistema funciona para ambos. No reemplaza la terapia, la complementa.'
}, {
  q: '¿Cómo recibo el material?',
  a: '100% digital en PDF. Después de tu compra recibís un email con el link de descarga en menos de 5 minutos. Podés leerlo en el celular, tablet o computadora.'
}, {
  q: '¿Qué lo diferencia de otros libros de autoayuda?',
  a: 'Tres cosas: 1) Está basado en neurociencia verificable con referencias incluidas. 2) No te dice pensá positivo, te da un sistema de 3 pasos con estructura. 3) Tiene herramientas para esta noche y para los próximos 90 días.'
}, {
  q: '¿Sirve aunque haga tiempo que tengo insomnio?',
  a: 'Sí. El Método Neuro-Dump trabaja con el sistema nervioso independientemente de cuánto tiempo lleves con rumiación. Lo que cambia es el tiempo de implementación, no la efectividad.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días completos. Si no es lo que esperabas por cualquier motivo, escribís a nuestro contacto y devolvemos el 100% sin preguntas ni formularios.'
}, {
  q: '¿La opción completa vale la diferencia?',
  a: 'Si querés herramientas para esta noche y las próximas 2 semanas: la colección base alcanza. Si querés transformar tu sistema nervioso en 90 días y tener protocolos para cuando la vida se ponga difícil: la opción completa es la inversión correcta.'
}];
export function FAQ() {
  return <section className="bg-cream py-12 md:py-24 px-4" data-id="element-173">
      <div className="max-w-3xl mx-auto" data-id="element-174">
        <div className="text-center mb-16" data-id="element-175">
          <h2 className="font-display font-bold text-navy text-[36px] mb-4" data-id="element-176">
            ❓ Lo que más nos preguntan
          </h2>
          <p className="text-taupe font-sans" data-id="element-177">
            Despejá tus dudas y empezá hoy mismo.
          </p>
        </div>

        <div className="space-y-4" data-id="element-178">
          {faqs.map((faq, i) => <details key={i} className="group bg-white rounded-xl border-l-[3px] border-sage overflow-hidden shadow-sm" data-id="element-179">
              <summary className="flex items-center justify-between p-6 cursor-pointer font-sans font-bold text-navy list-none" data-id="element-180">
                {faq.q}
                <span className="text-gold group-open:rotate-180 transition-transform" data-id="element-181">
                  ▼
                </span>
              </summary>
              <div className="px-6 pb-6 text-[#2D2D2D] font-sans leading-relaxed" data-id="element-182">
                {faq.a}
              </div>
            </details>)}
        </div>
      </div>
    </section>;
}